export const contactoData = {
    ES: {
        titulos: {
            contacto: "CONTÁCTANOS EN MÉXICO",
            siguen: "SÍGUENOS EN",
            redes: "REDES SOCIALES"
        },
        telefonos: [
            {
                region: "CENTRO",
                numero: "+52 554 859 57 59"
            },
            {
                region: "SURESTE",
                numero: "+52 229 413 10 73"
            },
            {
                region: "OCCIDENTE",
                numero: "+52 331 112 79 46"
            }
        ],
        redesSociales: [
            {
                plataforma: "facebook",
                link: "https://www.facebook.com/Hisol.GranAltura",
                icono: "FaFacebookF"
            },
            {
                plataforma: "instagram",
                link: "https://www.instagram.com/hisol.ca?igsh=eXUzMHh5MnplZGxv",
                icono: "FaInstagram"
            },
            {
                plataforma: "youtube",
                link: "https://youtube.com/@hisol.granaltura?si=h6r8nv7yAnaQYusL",
                icono: "FaYoutube"
            },
            {
                plataforma: "tiktok",
                link: "https://www.tiktok.com/@hisol.ca?_t=ZS-8wKstOhAZgy&_r=1",
                icono: "FaTiktok"
            },
            {
                plataforma: "linkedin",
                link: "https://www.linkedin.com/company/hisol-mexico/",
                icono: "FaLinkedinIn"
            },
        ]
    },
    EN: {
        titulos: {
            contacto: "CONTACT US IN MEXICO",
            siguen: "FOLLOW US ON",
            redes: "SOCIAL MEDIA"
        },
        telefonos: [
            {
                region: "CENTRAL",
                numero: "+52 554 859 57 59"
            },
            {
                region: "SOUTHEAST",
                numero: "+52 229 413 10 73"
            },
            {
                region: "WEST",
                numero: "+52 331 112 79 46"
            }
        ],
        redesSociales: [
            {
                plataforma: "facebook",
                link: "https://www.facebook.com",
                icono: "FaFacebookF"
            },
            {
                plataforma: "instagram",
                link: "https://www.instagram.com",
                icono: "FaInstagram"
            },
            {
                plataforma: "youtube",
                link: "https://www.youtube.com",
                icono: "FaYoutube"
            },
            {
                plataforma: "tiktok",
                link: "https://www.tiktok.com/company",
                icono: "FaTiktok"
            },
            {
                plataforma: "linkedin",
                link: "https://www.linkedin.com/company",
                icono: "FaLinkedinIn"
            },
        ]
    }
};
